import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import { ReactComponent as CustomPlanPromoIcon } from './custom-plan-promo.svg';
import { BillingPlanCardProps } from './use-billing-plans';
import styles from './BillingPlans.module.css';
import { Divider } from 'antd';

export const PlanDescription = ({
  option,
  className,
  isAgency,
}: {
  option: BillingPlanCardProps;
  className?: string;
  isAgency?: boolean;
}) => (
  <div
    id={
      option.planCode
        ? `billing-plan-description__${option.planCode}`
        : undefined
    }
    className={classNames(styles.points, className, {
      [styles.customPlan]: option.isCustom,
    })}
  >
    {option.pointsTitle && (
      <div className={styles.pointsTitle}>{option.pointsTitle}</div>
    )}
    {option.points?.map((point, idx) => (
      <div key={uniqueId(point)}>
        <div
          className={classNames(styles.pointContainer, styles.mainPoint)}
          key={uniqueId(point)}
        >
          {option.pointsIcons?.[idx] ? (
            <img src={option.pointsIcons?.[idx]} />
          ) : (
            <CheckOutlined className={styles.checkIcon} />
          )}
          {point}
        </div>
        {isAgency && option.costs?.[idx] && (
          <div className={styles.agencyCostItem}>{option.costs?.[idx]}</div>
        )}
        {isAgency && idx === 0 && <Divider className={styles.divider} />}
      </div>
    ))}
    {option.secondaryPoints?.map(point => (
      <div
        className={styles.pointContainer}
        key={uniqueId(typeof point === 'string' ? point : '')}
      >
        {!option.isFreeTrial && <CheckOutlined className={styles.checkIcon} />}

        {point}
      </div>
    ))}
    {option.isCustom && (
      <div className={styles.customPromo}>
        <CustomPlanPromoIcon />
        <div>SUPER CAPTURE PIXEL Capture 15% more leads</div>
      </div>
    )}
  </div>
);
